<template>
  <div class="d-flex justify-end mx-3 mt-3" v-if="isClubManager">
    <v-icon @click="edit = !edit" color="primary" size="40" >{{ edit ? 'mdi-arrow-u-left-top' : 'mdi-pencil' }}</v-icon>
  </div>

  <v-list v-if="!edit" density="compact">
    <v-list-item>
      <v-list-item-title class="d-inline">Název oddílu:</v-list-item-title>
      {{ props.club.club_name }}
    </v-list-item>
    <v-list-item>
      <v-list-item-title class="d-inline">Stát:</v-list-item-title>
      {{ props.club.club_country }}
    </v-list-item>
    <v-list-item>
      <v-list-item-title class="d-inline">Adresa:</v-list-item-title>
      {{ props.club.address }}
    </v-list-item>
    <v-list-item>
      <v-list-item-title class="d-inline">Email:</v-list-item-title>
      {{ props.club.email }}
    </v-list-item>
    <v-list-item>
      <v-list-item-title class="d-inline">Web:</v-list-item-title>
      {{ props.club.www }}
    </v-list-item>
    <v-list-item>
      <v-list-item-title class="d-inline">Telefon:</v-list-item-title>
      {{ props.club.tel }}
    </v-list-item>
    <v-list-item>
      <v-list-item-title class="d-inline">IČ:</v-list-item-title>
      {{ props.club.ic }}
    </v-list-item>
  </v-list>
  <v-form v-else ref="formRef" v-model="formValid">
    <v-text-field v-model="localClub.address" label="Adresa" maxlength="80" counter />
    <v-text-field v-model="localClub.email" label="Email" :rules="emailRules" maxlength="40" counter />
    <v-text-field v-model="localClub.www" label="Web" maxlength="50" counter />
    <v-text-field v-model="localClub.tel" label="Telefon" maxlength="14" counter />
    <v-text-field v-model="localClub.ic" type="number" label="IČ" />
    <v-alert type="error" v-if="errorMessage" class="my-2">{{errorMessage }}</v-alert>
    <v-btn @click="submitAboutClub" :disabled="!formValid" color="primary">Uložit</v-btn>
  </v-form>
  
</template>
<script setup>

import { ref, reactive, watch } from 'vue';
import {useSnackbarStore} from '@/stores/snackbarStore'
import apiClient from '/api.js';
import { useRoute } from 'vue-router';



const props = defineProps({
  club: {
    type: Object,
    required: true
  },
  isClubManager: {
    type: Boolean,
    default: false
  },
  assistUser: {
    type: Object,
    default: null
  }
});

const emit = defineEmits(['fetchClub']);


const snackbar = useSnackbarStore()
const route = useRoute();


const errorMessage = ref('');

const emailRules = [ v => !v || /.+@.+\..+/.test(v) || 'Email musí být platný',];
const formValid = ref(false);

const edit = ref(false);
const club_shortcut = ref(route.params.id);

const localClub = reactive({ ...props.club });

// Synchronizace props s lokální kopií, když se props změní
watch(() => props.club, (newClub) => {
  Object.assign(localClub, newClub);
});

const submitAboutClub = async () => {
  try {

    await apiClient.put(`/club/?club_shortcut=${club_shortcut.value}`, {
      club_name: localClub.club_name,
      club_country: localClub.club_country,
      address: localClub.address,
      email: localClub.email,
      www: localClub.www,
      tel: localClub.tel,
      ic: localClub.ic
    }); 

    emit("fetchClub");
    snackbar.showSnackbar('Informace o oddíle byly úspěšně aktualizovány.');
    errorMessage.value = '';
    
  } catch (error) {
    errorMessage.value = "Informace o oddíle se nepodařilo uložit.";
  }

}


</script>

<style scoped>


  .v-list-item-title {
    font-weight: bold;
  }

</style>